/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import CSSModules from 'react-css-modules';
import isNil from 'lodash/isNil';
import { Link } from 'react-router';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
  Button,
  Panel,
} from 'react-bootstrap';
import {
  connect,
} from 'react-redux';
import { injectIntl } from 'react-intl';
import RichButton from 'loracoms/RichButton';
import Nvl from 'loracoms/Nvl';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import registerActions from 'loraactions/register';
import accountActions from 'loraactions/account';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import styles from './styles.scss';
import imgRegSucc from './images/check.svg';
import EmailLinks from './emaillinks.json';


const kEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  getCaptcha: React.PropTypes.func.isRequired,
  captcha: React.PropTypes.object.isRequired,
  forgetPassword: React.PropTypes.func.isRequired,
  forgetSent: React.PropTypes.object.isRequired,
};

class LostPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      captcha: props.captcha,
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'email')
          .add('FE_EMPTY', 'vcode')
      ),
      submitted: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'lostpassword');
    this.handleReloadCaptcha = this.handleReloadCaptcha.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeVerifyCode = this.handleChangeVerifyCode.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.gotoEmailLogin = this.gotoEmailLogin.bind(this);
  }

  componentWillMount() {
    const { getCaptcha } = this.props;
    getCaptcha();
  }

  componentWillReceiveProps(nextProps) {
    const { captcha, forgetSent } = nextProps;
    if (captcha !== this.props.captcha) {
      this.setState({ captcha });
    }
    if (forgetSent !== this.props.forgetSent) {
      this.setState({ submitStatus: forgetSent.status });
      const { status } = forgetSent;
      if (status === 'failure') {
        const { errors } = this.state;
        this.setState({
          errors: errors.add(forgetSent.error.code, 'submit'),
        });
      }

      const { getCaptcha } = nextProps;
      getCaptcha();
    }
  }

  handleReloadCaptcha() {
    const { getCaptcha } = this.props;
    getCaptcha();
  }

  checkEmail(v, errors = this.state.errors) {
    if (isNil(v) || v === '') {
      return errors.add('FE_EMPTY', 'email');
    } else if (!kEmailRegex.test(v)) {
      return errors.add('FE_INVALIDEMAIL', 'email');
    }
    return errors.remove('email');
  }

  handleChangeEmail(e) {
    const email = e.target.value.trim();
    this.setState({
      email,
      errors: this.checkEmail(email),
    });
  }

  checkVerifyCode(v, errors = this.state.errors) {
    if (isNil(v) || v === '') {
      return errors.add('FE_EMPTY', 'vcode');
    }
    return errors.remove('vcode');
  }

  handleChangeVerifyCode(e) {
    const verifyCode = e.target.value.trim();
    this.setState({
      verifyCode,
      errors: this.checkVerifyCode(verifyCode),
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    const { captcha } = this.state;
    if (captcha.status !== 'success') {
      return;
    }

    let { errors } = this.state;
    errors = errors.remove('submit');
    this.setState({ errors });
    if (!errors.isEmpty()) {
      return;
    }

    const { forgetPassword } = this.props;
    const { data: { key } } = captcha;
    const { email, verifyCode } = this.state;
    forgetPassword(email, key, verifyCode, 'lora');
  }

  gotoEmailLogin() {
    const links = EmailLinks.links;
    const domain = _.split(this.state.email, '@')[1];
    const matches = _.filter(links, lk => lk.domain === domain);
    if (matches.length > 0) {
      window.open(`http://${matches[0].link}`);
    }
  }

  renderForm() {
    const { captcha, submitStatus = '', errors, submitted } = this.state;
    let captchaNode = <Nvl />;
    if (captcha.status === 'success') {
      captchaNode = (
        <Link onClick={this.handleReloadCaptcha}>
          <img alt="" src={captcha.data.src} />
        </Link>
      );
    }

    return (
      <div>
        <h1>{this.intlMsg.msg('title')}</h1>
        <div>
          <div styleName="wrapper-form">
            <Panel bsStyle="aisz-white">
              <div styleName="form-wrapper">
                <Form horizontal onSubmit={this.handleSubmit}>
                  <FormGroup validationState={submitted && errors.has('email') ? 'error' : undefined}>
                    <Col md={3} componentClass={ControlLabel}>
                      {this.intlMsg.msg('email')}
                    </Col>
                    <Col md={6}>
                      <FormControl
                        bsClass="aisz-form-control-f"
                        placeholder={this.intlMsg.msg('email.placeholder')}
                        onChange={this.handleChangeEmail}
                      />
                      <ControlTips
                        show={submitted && errors.has('email')}
                        message={this.intlMsg.errorMsg(errors.get('email'))}
                        azStyle="danger"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup validationState={submitted && errors.has('vcode') ? 'error' : undefined}>
                    <Col md={3} componentClass={ControlLabel}>
                      {this.intlMsg.msg('verifycode')}
                    </Col>
                    <Col md={3}>
                      <FormControl
                        bsClass="aisz-form-control-f"
                        onChange={this.handleChangeVerifyCode}
                      />
                      <ControlTips
                        show={submitted && errors.has('vcode')}
                        message={this.intlMsg.errorMsg(errors.get('vcode'))}
                        azStyle="danger"
                      />
                    </Col>
                    <Col md={3}>
                      <div className={styles.captcha}>
                        {captchaNode}
                      </div>
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col mdOffset={3} md={6}>
                      <div styleName="submit">
                        <RichButton
                          status={submitStatus}
                          states={[{
                            status: 'default',
                            label: <span>{this.intlMsg.msg('submit')}</span>,
                            type: 'submit',
                          }, {
                            status: 'pending',
                            label: <span><i className="fa fa-spinner fa-spin" />{' '}{this.intlMsg.msg('submit.pending')}</span>,
                            style: 'info',
                          }, {
                            status: 'success',
                            label: <span>{this.intlMsg.msg('submit.success')}</span>,
                            timer: () => this.setState({ submitStatus: '' }),
                            style: 'success',
                          }, {
                            status: 'failure',
                            label: <span>{this.intlMsg.msg('submit.failure')}</span>,
                            timer: () => this.setState({ submitStatus: '' }),
                            style: 'danger',
                          }]}
                        />
                      </div>
                      <FormBlock
                        azStyle="danger"
                        show={errors.has('submit')}
                        message={this.intlMsg.errorMsg(errors.get('submit'))}
                      />
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div styleName="regres">
        <div styleName="regres-body">
          <h1>
            <span styleName="regres-img">
              <img alt="" src={imgRegSucc} className="img-responsive" />
            </span>
            {this.intlMsg.msg('success.h1')}
          </h1>
          <p>
            {this.intlMsg.msg('success.p1')}
            <Link onClick={this.gotoEmailLogin}>{this.state.email}</Link>
            {this.intlMsg.msg('success.p2')}
          </p>
          <Button bsStyle="aisz-primary" onClick={this.gotoEmailLogin}>
            {this.intlMsg.msg('success.btn')}{' '}
            <i className="fa fa-external-link" />
          </Button>
        </div>
        <div styleName="regres-footer">
          <h3>
            {this.intlMsg.msg('success.footer.h3')}
          </h3>
          <ul>
            <li>
              {this.intlMsg.msg('success.footer.li1')}
            </li>
            <li>
              <Link onClick={() => this.setState({ submitStatus: '', email: '', verifyCode: '' })}>
                {this.intlMsg.msg('success.footer.li2.txt1')}
              </Link>
              {this.intlMsg.msg('success.footer.li2.txt2')}
            </li>
          </ul>
        </div>
      </div>
    );
  }

  render() {
    const { submitStatus } = this.state;
    let content = this.renderForm();
    if (submitStatus === 'success') {
      content = this.renderSuccess();
    }
    return (
      <div styleName="wrapper" style={{ minHeight: window.innerHeight }}>
        {content}
      </div>
    );
  }
}


LostPassword.propTypes = propTypes;

const mapStateToProps = state => ({
  captcha: state.register.captcha,
  forgetSent: state.account.forgetPassword,
});

const mapDispatchToProps = {
  getCaptcha: registerActions.captcha,
  forgetPassword: accountActions.forgetPassword,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(LostPassword, styles)));




// WEBPACK FOOTER //
// ./src/containers/LostPassword/index.jsx